import { useAuthorization } from 'components/Authorization';

let _isOU: boolean | null = null;

function isOUPayload(payload: Oversea.Token.Payload | null) {
  const { leyan_user, name, nimToken } = payload || {};

  if (import.meta.env.VITE_ENV === 'staging' || import.meta.env.VITE_ENV === 'feature') {
    return nimToken?.startsWith('fakeNimToken');
  }

  _isOU =
    Boolean(leyan_user && !leyan_user.userType && name === 'OU') ||
    Boolean(leyan_user?.userType === 'seller');

  return _isOU;
}

function useIsOU() {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  return isOUPayload(payload);
}

export function isOUValue() {
  return _isOU;
}

export default useIsOU;
